import { type Option, type ActiveFilter } from 'shared/components/Filter'
import { DIMENSION_OPERATORS_WITH_TYPES, OPERATOR_OPTIONS } from 'shared/constants/filterOperators'

export const sortInAlphabeticalOrder = (a: Option, b: Option): number =>
  a.label.localeCompare(b.label, undefined, { numeric: true })

const operatorById: Record<string, (typeof OPERATOR_OPTIONS)[string]> = {
  ...OPERATOR_OPTIONS,
  ...DIMENSION_OPERATORS_WITH_TYPES
}

export const updateFilterFormValues =
  ({ parameterOptions }: { parameterOptions: Option[] }) =>
  <TFilter extends ActiveFilter>(filter: TFilter, setValue: (name: string, value: any) => void) => {
    const parameter = parameterOptions.find((option) => option.value === filter.parameter.value)
    const parsedOperator = parameter?.operators?.[filter.operator] ?? operatorById[filter.operator]
    setValue('parameter', parameter)
    setValue('operator', parsedOperator)
    setValue('data', filter.data)
  }

export const transformFormValuesToFilters = <TParameter extends string>(
  formValues: Record<string, any>
): ActiveFilter<TParameter> => {
  return {
    parameter: {
      value: formValues.parameter.value,
      label: formValues.parameter.label,
      operators: formValues.parameter.operators
    },
    operator: formValues.operator.id,
    data: formValues.data
  }
}
